import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const InlineInspirationsPopoverDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InlineInspirationsPopover"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortLink"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"idBoardSource"}},{"kind":"Field","name":{"kind":"Name","value":"idMemberCreator"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idMember"}},{"kind":"Field","name":{"kind":"Name","value":"memberType"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"InlineInspirationsPopover","document":InlineInspirationsPopoverDocument}} as const;
export type InlineInspirationsPopoverQueryVariables = Types.Exact<{
  boardId: Types.Scalars['ID'];
}>;


export type InlineInspirationsPopoverQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id' | 'shortLink' | 'name' | 'idBoardSource' | 'idMemberCreator' | 'closed'>
    & { members: Array<(
      { __typename: 'Member' }
      & Pick<Types.Member, 'id'>
    )>, memberships: Array<(
      { __typename: 'Board_Membership' }
      & Pick<Types.Board_Membership, 'id' | 'idMember' | 'memberType'>
    )> }
  )> }
);

/**
 * __useInlineInspirationsPopoverQuery__
 *
 * To run a query within a React component, call `useInlineInspirationsPopoverQuery` and pass it any options that fit your needs.
 * When your component renders, `useInlineInspirationsPopoverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInlineInspirationsPopoverQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useInlineInspirationsPopoverQuery(
  baseOptions: TrelloQueryHookOptions<
    InlineInspirationsPopoverQuery,
    InlineInspirationsPopoverQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: InlineInspirationsPopoverDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    InlineInspirationsPopoverQuery,
    InlineInspirationsPopoverQueryVariables
  >(InlineInspirationsPopoverDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useInlineInspirationsPopoverLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    InlineInspirationsPopoverQuery,
    InlineInspirationsPopoverQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InlineInspirationsPopoverQuery,
    InlineInspirationsPopoverQueryVariables
  >(InlineInspirationsPopoverDocument, options);
}
export type InlineInspirationsPopoverQueryHookResult = ReturnType<
  typeof useInlineInspirationsPopoverQuery
>;
export type InlineInspirationsPopoverLazyQueryHookResult = ReturnType<
  typeof useInlineInspirationsPopoverLazyQuery
>;
export type InlineInspirationsPopoverQueryResult = Apollo.QueryResult<
  InlineInspirationsPopoverQuery,
  InlineInspirationsPopoverQueryVariables
>;
